import { MutationTree } from "vuex";

import { BddState } from "./types";

export const mutations: MutationTree<BddState> = {};
